import { useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import { NetworkIcon } from "lucide-react";
import TrashIcon from "../../../../assets/icons/TrashIcon";
import Message from "../../../../i18n/Message";
import { deleteGateway } from "../store/gatewayActionCreators";
import { linkToGateway } from "../../../../routes";

import "./GatewayTile.scss";

const routingStrategyLabels = {
  ROUND_ROBIN: "Round Robin",
  LATENCY_BASED: "Latency Based",
  LEAST_BUSY: "Least Busy",
  LOWEST_COST: "Lowest Cost",
};

const GatewayTile = ({ gateway }) => {
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const dispatch = useDispatch();
  const intl = useIntl();
  const nav = useNavigate();
  const { workspaceId } = useParams();

  const onDeleteConfirmed = (e) => {
    e.stopPropagation();
    dispatch(
      deleteGateway(intl, workspaceId, gateway.uid, () => {
        setShowDeleteConfirm(false);
      })
    );
  };

  const modelCount = gateway.models?.length || 0;

  return (
    <div className="campaign_tile card gateway_tile border-radius-lg d-flex">
      <div
        className="d-flex flex-column tile_body"
        onClick={() => nav(linkToGateway(workspaceId, gateway.uid))}
      >
        <div className="tile-name">
          <NetworkIcon size={24} color="#344767" />
          <span>{gateway.name}</span>
        </div>
        <div className="tile-info">
          <span className="info-item">
            {routingStrategyLabels[gateway.routingStrategy] || gateway.routingStrategy}
          </span>
          <span className="info-item">
            {modelCount} {modelCount === 1 ? "model" : "models"}
          </span>
        </div>
        <div className="metadata_row">
          <div className="meta_name">
            <Message id="created_on" />
          </div>
          <div className="meta_value">
            {dayjs(gateway.dateCreated).format("LLL")}
          </div>
        </div>
      </div>
      <div className="d-flex tile-actions">
        <div className="confirm_container">
          {showDeleteConfirm && (
            <>
              <div
                className="cover"
                onClick={(e) => {
                  e.stopPropagation();
                  setShowDeleteConfirm(false);
                }}
              ></div>
              <div className="confirm_panel">
                <button
                  className="btn bg-gradient-primary btn-sm"
                  onClick={onDeleteConfirmed}
                >
                  <Message id="confirm_delete" />
                </button>
              </div>
            </>
          )}
        </div>
        <button
          className="btn no-btn tile-action"
          onClick={(e) => {
            e.stopPropagation();
            setShowDeleteConfirm(!showDeleteConfirm);
          }}
        >
          <TrashIcon size="16" color="#344767" />
          <Message id="delete" />
        </button>
      </div>
    </div>
  );
};

export default GatewayTile;
